module.exports = __webpack_public_path__ + "img/MBOM-Impact-Sample-Application-min.5c2ad6fd.jpg";